// extracted by mini-css-extract-plugin
export default {"wrapper":"no-data_wrapper__igXPV","textWrapper":"no-data_textWrapper__65HZw","title":"no-data_title__amSC9","description":"no-data_description__s2lkC"};